module.exports = __webpack_public_path__ + "static/media/haase.93c03637.png";